import React from 'react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {Header, Button, Grid, Segment, Form, Loader} from 'semantic-ui-react';
import {
  TextAreaField,
  TextBoxField,
  InlineDollarField,
  Checkbox,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {
  checkIfIncludedsIn,
  compileContent,
  showDollarAmountWithDollar,
} from 'common/utils';
import _ from 'lodash';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {Alert} from 'componentLibrary';
import {
  TERMS_AND_CONDITIONS_TYPES,
  PREVIOUS_TERMS_AND_CONDITIONS,
  REMOVED,
} from 'app-ui-componentlibrary/dist/common/constants';
import ReactHtmlParser from 'react-html-parser';
import {produce} from 'immer';

const {SPECIAL, CUSTOM, STANDARD} = TERMS_AND_CONDITIONS_TYPES;

const MODALS = {
  VIEW: 'view',
  CREATE: 'create',
  EDIT: 'edit',
  NONE: 'none',
};

/** Requires TermsAndConditionsListener also mounted for full functionality **/
export class TermsAndConditions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      savingDataInitially: false,
      loading: true,
      alert: false,
      choosable: [],
      selectedTerm: false,
      openModal: MODALS.NONE,
      selectedIndex: -1,
      federalShare: 0,
    };
  }

  componentDidMount() {
    const {amendmentTask, data, entityType, pathToBeUsed} = this.props;
    let terms = _.get(data, 'terms', _.get(data, 'ehpConditions', null));
    const originalTermsAndConditions = _.get(this.props, PREVIOUS_TERMS_AND_CONDITIONS);
    const numStandardTC = this.getNumStandard();
    const numOrigAddedTC =
      _.get(this.props, `${PREVIOUS_TERMS_AND_CONDITIONS}.terms`, []).length -
      numStandardTC;

    this.setState({numStandardTC: numStandardTC, numOrigAddedTC: numOrigAddedTC});
    if (amendmentTask && !terms) {
      // if no existing amendment T&C, then copy original ones in the award to the amendment path
      this.props.saveEntityData(pathToBeUsed, entityType, originalTermsAndConditions);
    }

    // set total financial holding amount
    if (this.props && this.props.setTotalHoldingAmountExceedsFedShare) {
      let amendmentFedShare;
      let federalShare;
      if (this.props.entityType === 'amendment') {
        amendmentFedShare = _.get(
          this.props.context.amendment,
          'payload.grantAmendment.budget.share.fedShare',
          _.get(
            this.props.context.amendment,
            'payload.grantData.budget.share.fedShare',
            this.props.federalShare || 0
          )
        );
        federalShare = _.isArray(amendmentFedShare)
          ? _.sum(_.map(amendmentFedShare, _.toNumber))
          : amendmentFedShare;
      } else if (this.props.entityType === 'awardRecommendation') {
        amendmentFedShare = _.get(
          this.props.context.awardRecommendation,
          'payload.budget.share.fedShare',
          this.props.federalShare || 0
        );
        federalShare = _.isArray(amendmentFedShare)
          ? _.sum(_.map(amendmentFedShare, _.toNumber))
          : amendmentFedShare;
      } else if (this.props.entityType === 'subAwardRecommendation') {
        amendmentFedShare = _.get(
          this.props.context.subAwardRecommendation,
          'payload.budget.share.fedShare',
          this.props.federalShare || 0
        );
        federalShare = _.isArray(amendmentFedShare)
          ? _.sum(_.map(amendmentFedShare, _.toNumber))
          : amendmentFedShare;
      } else {
        federalShare = this.props.federalShare;
      }
      this.setState({federalShare});
      const totalHoldingAmount = this.parseTotalFinancialHoldings(this.getChosen());
      if (totalHoldingAmount > parseFloat(federalShare)) {
        this.props.setTotalHoldingAmountExceedsFedShare('context', true);
      } else {
        this.props.setTotalHoldingAmountExceedsFedShare('context', false);
      }
    }

    if (
      !_.get(this.props.rules, 'loading', true) &&
      !_.get(this.props, 'dataLoading', true)
    ) {
      this.recalculateChoosable();
      this.props.amendmentTask && this.getNumberIncludedTCinAward();
    }
  }

  componentDidUpdate(prevProps) {
    const needsUpdate =
      !_.get(this.props.rules, 'loading', true) &&
      !_.get(this.props, 'dataLoading', true) &&
      (this.state.loading || !_.isEqual(prevProps.data, this.props.data));

    if (needsUpdate) {
      this.recalculateChoosable();
      this.props.amendmentTask && this.getNumberIncludedTCinAward();
    }
  }

  getStandardAvailable = () => {
    let standardTerms = _.cloneDeep(
      _.filter(
        _.flatMap(
          _.get(
            this.props,
            this.props.amendmentTask
              ? 'previousTermsAndConditions.terms'
              : 'rules.payload',
            []
          )
        ),
        (term) => term.type === STANDARD
      )
    );

    _.forEach(standardTerms, (term, index) => {
      if (term) {
        term.order = index + 1;
      }
    });

    return standardTerms;
  };

  getSpecialAvailable = () => {
    return _.cloneDeep(
      _.filter(
        _.flatMap(_.get(this.props, 'rules.payload', [])),
        (term) => term.type === SPECIAL
      )
    );
  };

  getChosen = () => {
    const chosenTerms = _.cloneDeep(
      _.filter(_.get(this.props, 'data.terms'), (term) => {
        if (term) {
          return term.type === SPECIAL || term.type === CUSTOM || term.type === REMOVED;
        }
      })
    );

    return _.sortBy(chosenTerms, ['order']);
  };

  getNumStandard = () => {
    return _.filter(_.get(this.props, 'data.terms'), (term) => {
      if (term) {
        return term.type === STANDARD;
      }
    }).length;
  };

  getNumberIncludedTCinAward = () => {
    let chosen = this.getChosen();
    const includedTCsInAward = _.findLastIndex(chosen, (term) => {
      return !term.addedPostAward;
    });
    this.setState({
      includedTCsInAward: includedTCsInAward,
    });
  };

  recalculateChoosable() {
    let {data, pathToBeUsed, entityType} = this.props;
    let terms = _.get(data, 'terms', {});
    let choosable = this.getSpecialAvailable();
    let alert = this.state.alert;

    // Seperate all included special and custom terms and check if still valid
    _.forEach(terms, (term) => {
      if (term && term.type === SPECIAL) {
        _.remove(choosable, (x) => x.title === term.title);
      }
    });

    const oldAlert = _.get(this.props.data, 'needsAttention', false);

    this.setState(
      {
        loading: false,
        choosable,
        alert: oldAlert ? true : alert,
      },
      () => {
        // turn off alarm flag after viewing alarm
        this.props.saveEntityData(pathToBeUsed, entityType, {
          ...data,
          needsAttention: false,
        });
      }
    );
  }

  updateTerms = (chosen) => {
    const {pathToBeUsed, entityType, data} = this.props;
    let included = _.cloneDeep(this.getStandardAvailable().concat(chosen));
    this.setState({
      openModal: MODALS.NONE,
    });

    const dataToBeUsed = data ? data : {terms: []};
    this.props.saveEntityData(pathToBeUsed, entityType, {
      ...dataToBeUsed,
      terms: included,
    });
    if (Array.isArray(chosen)) {
      const totalHoldingAmount = this.parseTotalFinancialHoldings(chosen);
      if (totalHoldingAmount > parseFloat(this.state.federalShare)) {
        this.props.setTotalHoldingAmountExceedsFedShare('context', true);
      } else {
        this.props.setTotalHoldingAmountExceedsFedShare('context', false);
      }
    }
  };

  handleRemoveTerm = (index) => {
    let chosen = this.getChosen();

    chosen.splice(index, 1);

    // Only want to update orders AFTER the removed term
    let afterRemoved = chosen.slice(index);
    _.forEach(afterRemoved, (term) => term.order--);
    // Replace terms with updated ones
    chosen = chosen.slice(0, index).concat(afterRemoved);
    this.updateTerms(chosen);
  };

  handleToggleRemoveTerm = (index) => {
    const {context} = this.props;
    const {numStandardTC} = this.state;
    let originalTerms;
    switch (this.props.entityType) {
      case 'awardRecommendation':
        originalTerms = _.get(
          context,
          ['awardRecommendation', 'payload', 'termsAndConditions', 'terms'],
          []
        );
        break;
      default:
        originalTerms = _.get(
          context,
          ['amendment', 'payload', 'grantData', 'termsAndConditions', 'terms'],
          []
        );
    }

    let chosen = this.getChosen();
    const removed = _.get(chosen[index], 'removed', false);
    let newChosen = produce(chosen, (draft) => {
      if (removed) {
        _.set(draft, index, originalTerms[numStandardTC + index]);
      } else {
        _.set(draft[index], 'removed', true);
        _.set(draft[index], 'modified', false);
      }
    });
    const totalHoldingAmount = this.parseTotalFinancialHoldings(newChosen);
    if (totalHoldingAmount > parseFloat(this.state.federalShare)) {
      this.props.setTotalHoldingAmountExceedsFedShare('context', true);
    } else {
      this.props.setTotalHoldingAmountExceedsFedShare('context', false);
    }
    this.updateTerms(newChosen);
  };

  handleAddSpecialTerm = (index) => {
    let {choosable} = this.state;
    const {amendmentTask} = this.props;

    let term = choosable[index];
    term.order = this.getLatestOrder();
    this.setState({
      selectedTerm: {
        ...term,
        transformedText: compileContent(term.text, {
          financialHoldAmount: _.get(term, 'financialHoldAmount', 0),
          projectNumber: _.get(term, 'projectNumber', 'projectNumber'),
          projectTitle: _.get(term, 'projectTitle', 'projectTitle'),
          description: _.get(term, 'projectDescription', 'description'),
        }),
        disableButton: this.disableConfirmButton(term),
        addedPostAward: amendmentTask,
      },
      openModal: MODALS.CREATE,
    });
  };

  getLatestOrder = () => {
    const {amendmentTask} = this.props;
    const ehpConditions = _.get(
      this.props.context,
      [
        'amendment',
        'payload',
        'grantData',
        'termsAndConditions',
        'ehpConditions',
        0,
        'allConditions',
      ],
      []
    );

    const prevTerms = _.get(
      this.props.context,
      ['amendment', 'payload', 'grantData', 'termsAndConditions', 'terms'],
      []
    );
    let chosen = this.getChosen();
    const length = chosen.length;
    const maxChosenOrder = length > 0 ? chosen[length - 1].order : 0;

    /*
      In amendment tasks, the expectation is new terms or ehp conditions are added at the bottom of the Articles
      If an amendment is made with EHP conditions existing, latest order should be based on the max between ehp and term order
      If there are ehpConditions but they don't have orders, it might be legacy data.
    */
    if (amendmentTask && ehpConditions.length) {
      // Handling legacy data (EHP conditions without an order)
      // Assumed legacy EHP will be after original chosen terms.
      const prevTermOrder = _.get(prevTerms, [prevTerms.length - 1, 'order'], 0);
      const maxEhpOrder = _.get(ehpConditions, [0, 'order'], null)
        ? _.get(ehpConditions[ehpConditions.length - 1], 'order')
        : prevTermOrder + ehpConditions.length;

      let order = length > 0 ? _.max([maxEhpOrder, maxChosenOrder]) : maxEhpOrder;
      return order + 1;
    }

    return maxChosenOrder + 1;
  };

  handleUpButton(index) {
    let chosen = this.getChosen();
    let currentTerm = chosen[index];
    let tmp = currentTerm.order;
    currentTerm.order = chosen[index - 1].order;
    chosen[index - 1].order = tmp;
    chosen.splice(index - 1, 0, currentTerm);
    chosen.splice(index + 1, 1);
    this.updateTerms(chosen);
  }

  handleDownButton(index) {
    let chosen = this.getChosen();
    let currentTerm = chosen[index];
    let tmp = currentTerm.order;
    currentTerm.order = chosen[index + 1].order;
    chosen[index + 1].order = tmp;
    chosen.splice(index + 2, 0, currentTerm);
    chosen.splice(index, 1);
    this.updateTerms(chosen);
  }

  disableUpButton = (index, addedPostAward) => {
    // For preAward tasks, disable the first included T&C
    // For post Award amendments, disable up arrows for all T&C included in the award package
    //   as well as the first T&C which was added during post award tasks.
    let disabled = index < 1;
    if (this.props.amendmentTask) {
      disabled = index <= this.state.includedTCsInAward + 1 || !addedPostAward;
    }
    return disabled;
  };

  renderEditButton(term, index) {
    if (_.find(term.params, (param) => !param.readOnly) || term.type == CUSTOM) {
      return (
        <a
          href={`#${index}`}
          title={term.title}
          id={index}
          onClick={() =>
            this.setState({
              selectedTerm: term,
              selectedIndex: index,
              openModal: MODALS.EDIT,
            })
          }
        >
          Edit
        </a>
      );
    }
  }

  updateEditedObject = () => {
    const {selectedTerm, selectedIndex, numOrigAddedTC, numStandardTC} = this.state;
    const keysToRemove = ['order', 'modified'];
    let originalTCs = _.get(this.props, `${PREVIOUS_TERMS_AND_CONDITIONS}.terms`, []);
    let chosen = this.getChosen();

    let ctx = {};
    _.forEach(selectedTerm.params, (param) => {
      ctx[param.parameter] = param.value !== undefined ? param.value : '';
    });
    /*
    Special and Custom terms which are part of original award may be modified in the amendment workflow.
    The 'isModified' variable is the comparison of the incoming selectedTerm  to the corresponding original award term (ignoring
    the 'order' and 'modified' keys.)  This value is stored in the 'modified' property of the term. This calculation
    is necessary in the event that the term is changed and then returned to its original value.
    Terms which are added during the amendment process and then are changed again during the amendment process are 
    simply updated in the 'else' portion.
*/

    let newChosen = produce(chosen, (draft) => {
      if (selectedIndex < numOrigAddedTC) {
        // handles updates to terms from original award or terms which were approved in other amendment requests.
        const transformSelected = _.omit(selectedTerm, keysToRemove);
        const transformOrig = _.omit(
          originalTCs[numStandardTC + selectedIndex],
          keysToRemove
        );

        const isModified = !_.isEqual(transformSelected, transformOrig);
        draft[selectedIndex] = {
          ...selectedTerm,
          modified: isModified,
          transformedText: compileContent(selectedTerm.text, ctx),
        };
      } else {
        // handles changes made to terms added during amendment process
        draft[selectedIndex] = {
          ...selectedTerm,
          transformedText: compileContent(selectedTerm.text, ctx),
        };
      }
    });

    const totalHoldingAmount = this.parseTotalFinancialHoldings(newChosen);
    if (totalHoldingAmount > parseFloat(this.state.federalShare)) {
      this.props.setTotalHoldingAmountExceedsFedShare('context', true);
    } else {
      this.props.setTotalHoldingAmountExceedsFedShare('context', false);
    }

    return newChosen;
  };

  renderEditTermsModal() {
    const {selectedTerm} = this.state;
    return (
      <FemaGoModal
        title="Edit terms and conditions"
        size="large"
        open={this.state.openModal === MODALS.EDIT}
        disableButton={_.get(selectedTerm, 'disableButton', true)}
        buttonText="Confirm"
        confirmAction={() => {
          this.updateTerms(this.updateEditedObject());
        }}
        cancelAction={() => this.setState({openModal: MODALS.NONE})}
      >
        {selectedTerm.type === 'custom' ? (
          this.renderCustomTermParams()
        ) : (
          <React.Fragment>
            <h3>{this.state.selectedTerm.title}</h3>
            <p>{ReactHtmlParser(selectedTerm.transformedText || selectedTerm.text)}</p>
          </React.Fragment>
        )}
        {this.renderParams(selectedTerm)}
      </FemaGoModal>
    );
  }

  disableConfirmButton = (selectedTerm) => {
    let amendmentFedShare;
    let federalShare;

    if (this.props.entityType === 'amendment') {
      amendmentFedShare = _.get(
        this.props.context.amendment,
        'payload.grantAmendment.budget.share.fedShare',
        _.get(
          this.props.context.amendment,
          'payload.grantData.budget.share.fedShare',
          this.props.federalShare || 0
        )
      );
      federalShare = _.isArray(amendmentFedShare)
        ? _.sum(_.map(amendmentFedShare, _.toNumber))
        : amendmentFedShare;
    } else if (this.props.entityType === 'awardRecommendation') {
      amendmentFedShare = _.get(
        this.props.context.awardRecommendation,
        'payload.budget.share.fedShare',
        this.props.federalShare || 0
      );
      federalShare = _.isArray(amendmentFedShare)
        ? _.sum(_.map(amendmentFedShare, _.toNumber))
        : amendmentFedShare;
    } else if (this.props.entityType === 'subAwardRecommendation') {
      amendmentFedShare = _.get(
        this.props.context.subAwardRecommendation,
        'payload.budget.share.fedShare',
        this.props.federalShare || 0
      );
      federalShare = _.isArray(amendmentFedShare)
        ? _.sum(_.map(amendmentFedShare, _.toNumber))
        : amendmentFedShare;
    } else {
      federalShare = this.props.federalShare;
    }

    let invalidParams = false;
    _.forEach(selectedTerm.params, (param) => {
      if (
        !param.readOnly &&
        !param.optional &&
        (_.isNil(param.value) || param.value === '')
      ) {
        invalidParams = true;
      }
    });
    return (
      _.isEmpty(selectedTerm.title) ||
      _.isEmpty(selectedTerm.text) ||
      invalidParams ||
      (selectedTerm.financialHold &&
        _.toNumber(selectedTerm.financialHoldAmount) > _.toNumber(federalShare)) ||
      _.toNumber(selectedTerm.financialHoldAmount) === 0 ||
      false
    );
  };

  parseTotalFinancialHoldings = (data) => {
    let result = 0;
    if (!data || data.length < 1) {
      return result;
    }
    for (let term of data) {
      if (term && term.financialHoldAmount && term.removed !== true) {
        result += parseFloat(term.financialHoldAmount);
      }
    }
    return result;
  };

  handleChangeParams = (index, value) => {
    let amendmentFedShare;
    let federalShare;

    if (this.props.entityType === 'amendment') {
      amendmentFedShare = _.get(
        this.props.context.amendment,
        'payload.grantAmendment.budget.share.fedShare',
        _.get(
          this.props.context.amendment,
          'payload.grantData.budget.share.fedShare',
          this.props.federalShare || 0
        )
      );
      federalShare = _.isArray(amendmentFedShare)
        ? _.sum(_.map(amendmentFedShare, _.toNumber))
        : amendmentFedShare;
    } else if (this.props.entityType === 'awardRecommendation') {
      amendmentFedShare = _.get(
        this.props.context.awardRecommendation,
        'payload.budget.share.fedShare',
        this.props.federalShare || 0
      );
      federalShare = _.isArray(amendmentFedShare)
        ? _.sum(_.map(amendmentFedShare, _.toNumber))
        : amendmentFedShare;
    } else if (this.props.entityType === 'subAwardRecommendation') {
      amendmentFedShare = _.get(
        this.props.context.subAwardRecommendation,
        'payload.budget.share.fedShare',
        this.props.federalShare || 0
      );
      federalShare = _.isArray(amendmentFedShare)
        ? _.sum(_.map(amendmentFedShare, _.toNumber))
        : amendmentFedShare;
    } else {
      federalShare = this.props.federalShare;
    }
    let chosen = this.getChosen();
    let totalIncludedFianacialHold = 0;
    this.setState({
      selectedTerm: produce(this.state.selectedTerm, (selectedTerm) => {
        const paramAtIndex = selectedTerm.params[index];
        selectedTerm[paramAtIndex.parameter] = value;
        paramAtIndex.value = value;
        let ctx = {};
        _.forEach(selectedTerm.params, (param) => {
          ctx[param.parameter] = !_.isEmpty(param.value)
            ? param.value
            : param.parameter === 'financialHoldAmount'
            ? 0
            : param.parameter;
        });
        // check for fiancial hold amount validity
        totalIncludedFianacialHold = this.parseTotalFinancialHoldings(chosen);
        const currentHoldAmount = parseFloat(selectedTerm.financialHoldAmount);
        if (totalIncludedFianacialHold + currentHoldAmount > parseFloat(federalShare)) {
          this.props.setTotalHoldingAmountExceedsFedShare('context', true);
        } else {
          this.props.setTotalHoldingAmountExceedsFedShare('context', false);
        }

        const transformedText = compileContent(selectedTerm.text, ctx);
        selectedTerm.financialHold = !!selectedTerm.financialHoldAmount;
        if (!checkIfIncludedsIn([undefined, null, ''], transformedText)) {
          selectedTerm.transformedText = transformedText;
        }
        selectedTerm.disableButton = this.disableConfirmButton(selectedTerm);
      }),
    });
  };

  renderParams(selectedTerm) {
    const renderedParams = _.map(selectedTerm.params, (param, index) => {
      let field;
      let {unitType, parameter, optional, displayText, value} = param;
      switch (unitType) {
        case 'dollar':
          field = (
            <InlineDollarField
              key={index}
              id={parameter}
              name={parameter}
              hintText={displayText}
              value={value}
              size="small"
              optional={optional}
              handleBlur={() => {}}
              handleChange={(name, value) => this.handleChangeParams(index, value)}
            />
          );
          break;
        case 'text':
          field = (
            <TextBoxField
              key={index}
              id={parameter}
              name={parameter}
              hintText={displayText}
              value={value}
              size="small"
              optional={optional}
              handleBlur={() => {}}
              handleChange={(e) => this.handleChangeParams(index, e.target.value)}
            />
          );
          break;
        case 'textarea':
          field = (
            <TextAreaField
              key={index}
              id={parameter}
              name={parameter}
              hintText={displayText}
              value={value}
              size="small"
              optional={optional}
              handleBlur={() => {}}
              handleChange={(e, {value}) => this.handleChangeParams(index, value)}
            />
          );
          break;
        default:
      }
      return <Grid.Row key={parameter}>{field}</Grid.Row>;
    });
    return (
      renderedParams.length > 0 && (
        <React.Fragment>
          <Header as="h3">Parameters</Header>
          <Grid>{renderedParams}</Grid>
        </React.Fragment>
      )
    );
  }

  renderCustomTermParams = () => {
    const {fundingHold} = this.props;
    const {selectedTerm} = this.state;
    const handleChangeCreateCustom = (e) => {
      const {name, value} = e.target;
      this.setState({
        selectedTerm: produce(selectedTerm, (draft) => {
          draft[name] = value;
          draft.disableButton = this.disableConfirmButton(draft);

          let ctx = {};
          _.forEach(selectedTerm.params, (param) => {
            ctx[param.parameter] = !_.isEmpty(param.value)
              ? param.value
              : param.parameter === 'financialHoldAmount'
              ? 0
              : param.parameter;
          });
          const transformedText = compileContent(draft.text, ctx);
          draft.financialHold = !!draft.financialHoldAmount;
          if (!!transformedText) {
            draft.transformedText = transformedText;
          }
        }),
      });
    };

    return (
      <React.Fragment>
        <Form>
          <TextBoxField
            size="large"
            label="Enter term and condition title"
            name="title"
            value={selectedTerm.title}
            handleBlur={handleChangeCreateCustom}
            handleChange={handleChangeCreateCustom}
          />
          <TextAreaField
            rows={12}
            name="text"
            title="Enter term and condition text"
            label="Enter term and condition text"
            value={selectedTerm.text}
            handleBlur={handleChangeCreateCustom}
            handleChange={handleChangeCreateCustom}
          />
          {fundingHold === true && (
            <Checkbox
              checked={selectedTerm.fundingHold}
              label="Funding hold"
              handleChange={(_, isChecked) => {
                handleChangeCreateCustom({
                  target: {
                    name: 'fundingHold',
                    value: isChecked,
                  },
                });
              }}
            />
          )}
        </Form>
      </React.Fragment>
    );
  };

  handleViewTermsModal = (term) => {
    this.setState({
      openModal: MODALS.VIEW,
      selectedTerm: term,
    });
  };

  renderViewTermsModal = () => {
    const {selectedTerm} = this.state;
    const renderedParams = _.map(
      selectedTerm.params,
      (param, index) =>
        (param.parameter !== 'financialHoldAmount' || param.value === undefined) && (
          <p key={`displayText-${index}`}>
            <strong>{param.displayText}</strong>: {param.unitType === 'dollar' ? '$' : ''}
            {param.value}
          </p>
        )
    );
    return (
      <FemaGoModal
        title="View terms and conditions"
        type="alert"
        size="large"
        open={this.state.openModal === MODALS.VIEW}
        confirmButton="hidden"
        confirmAction={() => {}}
        cancelAction={() => this.setState({openModal: MODALS.NONE})}
      >
        <Segment vertical textAlign="left">
          <h3>{selectedTerm.title}</h3>
          <p>{ReactHtmlParser(selectedTerm.transformedText || selectedTerm.text)}</p>
          {selectedTerm.financialHoldAmount !== undefined && (
            <p>
              <strong>Financial hold amount</strong>:{' '}
              {showDollarAmountWithDollar(selectedTerm.financialHoldAmount)}
            </p>
          )}
          {renderedParams}
          {selectedTerm.type === CUSTOM && selectedTerm.fundingHold === true && (
            <Checkbox
              label="Funding hold"
              checked={selectedTerm.fundingHold}
              disabled={true}
            />
          )}
        </Segment>
      </FemaGoModal>
    );
  };

  handleCreateTermButton() {
    this.setState({
      openModal: MODALS.CREATE,
      selectedTerm: {
        type: CUSTOM,
        order: this.getLatestOrder(),
        params: this.props.customTermParams,
      },
    });
  }

  renderCreateTermModal() {
    const {amendmentTask} = this.props;
    let {selectedTerm} = this.state;
    let chosen = this.getChosen();
    if (selectedTerm.type === CUSTOM) {
      if (amendmentTask) selectedTerm = {...selectedTerm, addedPostAward: true};
      return (
        <FemaGoModal
          title="Custom terms and conditions"
          size="large"
          open={this.state.openModal === MODALS.CREATE}
          buttonText="Confirm"
          disableButton={_.get(selectedTerm, 'disableButton', true)}
          confirmAction={(e) => {
            chosen.push(selectedTerm);
            this.updateTerms(chosen);
          }}
          cancelAction={() => this.setState({openModal: MODALS.NONE})}
        >
          {this.renderCustomTermParams()}
          {this.renderParams(selectedTerm)}
        </FemaGoModal>
      );
    } else {
      return (
        <FemaGoModal
          title="Include terms and conditions"
          size="large"
          open={this.state.openModal === MODALS.CREATE}
          buttonText="Confirm"
          disableButton={_.get(selectedTerm, 'disableButton', true)}
          confirmAction={(e) => {
            chosen.push(
              produce(selectedTerm, (draft) => {
                _.forEach(draft.params, (param) => {
                  draft[param.parameter] = param.value;
                  draft.financialHold = !!draft.financialHoldAmount;
                });
              })
            );
            this.updateTerms(chosen);
          }}
          cancelAction={() => this.setState({openModal: MODALS.NONE})}
        >
          <React.Fragment>
            <h3>{selectedTerm.title}</h3>
            <div>
              {ReactHtmlParser(selectedTerm.transformedText || selectedTerm.text)}
            </div>
            {this.renderParams(selectedTerm)}
            {selectedTerm.financialHoldAmount &&
              _.findIndex(
                selectedTerm.params,
                (param) => param.parameter === 'financialHoldAmount'
              ) === -1 && (
                <p>Financial Hold Amount: ${selectedTerm.financialHoldAmount}</p>
              )}
          </React.Fragment>
        </FemaGoModal>
      );
    }
  }

  renderAlert() {
    const {alert} = this.state;
    return (
      alert && (
        <Alert
          size="mini"
          header="Terms and conditions warning"
          content="The available and/or included terms may have changed. Please review the terms and conditions to ensure they are correct."
          type="warning"
          dismissable={false}
        />
      )
    );
  }

  renderAvailable = () => {
    const {choosable} = this.state;
    return (
      <React.Fragment>
        <FemaGoTable type="static" summary="Available terms and conditions">
          <FemaGoTable.Header>
            <FemaGoTable.Row>
              <FemaGoTable.HeaderCell>Term</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>Title</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell textAlign="right">View</FemaGoTable.HeaderCell>
            </FemaGoTable.Row>
          </FemaGoTable.Header>
          <FemaGoTable.Body>
            {choosable &&
              _.map(choosable, (term, index) => (
                <FemaGoTable.Row key={index}>
                  <FemaGoTable.TextCell width={1}>
                    <a
                      href="#"
                      title={term.title}
                      onClick={(e) => {
                        e.preventDefault();
                        this.handleAddSpecialTerm(index);
                      }}
                    >
                      Add
                    </a>
                  </FemaGoTable.TextCell>
                  <FemaGoTable.TextCell>{term.title}</FemaGoTable.TextCell>
                  <FemaGoTable.TextCell textAlign="right">
                    <a
                      href="#"
                      title={term.title}
                      onClick={() => this.handleViewTermsModal(term)}
                    >
                      View
                    </a>
                  </FemaGoTable.TextCell>
                </FemaGoTable.Row>
              ))}
          </FemaGoTable.Body>
        </FemaGoTable>
        <Grid.Column width={10}>
          <a
            href="#"
            title="Create custom term"
            onClick={() => this.handleCreateTermButton()}
          >
            + Create Custom Term{' '}
          </a>
        </Grid.Column>
      </React.Fragment>
    );
  };

  renderIncluded = () => {
    let chosen = this.getChosen();
    const {amendmentTask} = this.props;
    return (
      <React.Fragment>
        <FemaGoTable type="static" summary="Included terms and conditions">
          <FemaGoTable.Header>
            <FemaGoTable.Row>
              <FemaGoTable.HeaderCell>Reorder</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>Title</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell textAlign="right">View</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell textAlign="right">Edit</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell textAlign="right">Remove</FemaGoTable.HeaderCell>
            </FemaGoTable.Row>
          </FemaGoTable.Header>
          <FemaGoTable.Body>
            {chosen &&
              _.map(
                chosen,
                (term, index) =>
                  term.type != 'removed' && (
                    <FemaGoTable.Row
                      key={index}
                      background={term.removed ? 'removed' : null}
                    >
                      <FemaGoTable.TextCell>
                        <Button
                          className="ui icon button"
                          onClick={() => this.handleUpButton(index)}
                          disabled={this.disableUpButton(index, term.addedPostAward)}
                          title={`move up ${term.title}`}
                        >
                          <i className={'arrow up icon'} />
                        </Button>
                        <Button
                          className="ui icon button"
                          onClick={() => this.handleDownButton(index)}
                          disabled={
                            index + 1 >= chosen.length ||
                            (amendmentTask && !term.addedPostAward)
                          }
                          title={`move down ${term.title}`}
                        >
                          <i className={'arrow down icon'} />
                        </Button>
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>{term.title}</FemaGoTable.TextCell>
                      <FemaGoTable.TextCell textAlign="right">
                        <a
                          href="#"
                          title={term.title}
                          onClick={() => this.handleViewTermsModal(term)}
                        >
                          View
                        </a>
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell textAlign="right">
                        {!term.removed && this.renderEditButton(term, index)}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell textAlign="right">
                        <a
                          href="#"
                          title={term.title}
                          onClick={(e) => {
                            e.preventDefault();
                            !amendmentTask || term.addedPostAward
                              ? this.handleRemoveTerm(index)
                              : this.handleToggleRemoveTerm(index); // in post award, toggle T&C included in original award package
                          }}
                        >
                          {term.removed ? 'Undo' : 'Remove'}
                        </a>
                      </FemaGoTable.TextCell>
                    </FemaGoTable.Row>
                  )
              )}
          </FemaGoTable.Body>
        </FemaGoTable>
      </React.Fragment>
    );
  };

  render() {
    const {id, header, headerSize} = this.props;
    return (
      <div id={id || 'termsAndConditions'}>
        {header && <Header as={headerSize || 'h1'}>{header}</Header>}
        {!this.state.loading && (
          <React.Fragment>
            {this.renderAlert()}
            {this.renderCreateTermModal()}
            {this.renderViewTermsModal()}
            {this.renderEditTermsModal()}
          </React.Fragment>
        )}
        <Segment>
          <Header as="h3">Available terms and conditions</Header>
          {!this.state.loading ? (
            this.renderAvailable()
          ) : (
            <Loader active inline="centered" content="Loading" />
          )}
        </Segment>
        <Segment>
          <Header as="h3">Included terms and conditions</Header>
          {!this.state.loading ? (
            this.renderIncluded()
          ) : (
            <Loader active inline="centered" content="Loading" />
          )}
        </Segment>
      </div>
    );
  }
}

export default connectDynamic(TermsAndConditions);
